module.exports = __webpack_public_path__ + "img/what3words-search-listing.3eca6456.svg";